module.exports = {"loader":"Generujem export","error":"Chyba generovanie exportu","success":"Export <b>{fileName}</b> bol úspešne vygenerovaný"}